//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./package.d.ts" />

import * as $ from "skir-client";

// -----------------------------------------------------------------------------
// enum PackageTier
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class PackageTier extends $._EnumBase {}

// -----------------------------------------------------------------------------
// enum Feature
// -----------------------------------------------------------------------------

/** Deeply immutable. */
export class Feature extends $._EnumBase {}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "package.skir",
  [
    {
      kind: "enum",
      ctor: PackageTier,
      name: "PackageTier",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "ESSENTIALS",
          number: 1,
        },
        {
          name: "PROFESSIONAL",
          number: 2,
        },
        {
          name: "ENTERPRISE",
          number: 3,
        },
      ],
    },
    {
      kind: "enum",
      ctor: Feature,
      name: "Feature",
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "CRM_SYNC",
          number: 1,
        },
        {
          name: "TODO_MANAGER",
          number: 2,
        },
        {
          name: "KNOWLEDGE_BASE",
          number: 3,
        },
        {
          name: "LIVE_ASK_QUBI",
          number: 4,
        },
        {
          name: "LIVE_COACHING",
          number: 5,
        },
        {
          name: "LIVE_METHODOLOGY",
          number: 6,
        },
        {
          name: "TAXONOMY_ANALYTICS",
          number: 7,
        },
        {
          name: "TEAM_ANALYTICS",
          number: 8,
        },
        {
          name: "AI_COACHING_SCORECARDS",
          number: 9,
        },
        {
          name: "AUTOPILOT",
          number: 20,
        },
        {
          name: "MCP_SERVER",
          number: 21,
        },
        {
          name: "CUSTOM_METHODOLOGY",
          number: 22,
        },
        {
          name: "REP_IMPROVEMENT_PATHS",
          number: 23,
        },
        {
          name: "SSO_SCIM",
          number: 24,
        },
        {
          name: "API_ACCESS",
          number: 25,
        },
      ],
    },
  ]
);
